/* eslint-disable jsx-a11y/anchor-is-valid */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';

function ProviderIdLinkRenderer(props) {
  const { readOnly, value } = props;
  return (
    <a
      target="_blank"
      href="#"
      tabIndex="0"
      onClick={(e) => {
        e.preventDefault();
        if (!readOnly) {
          props.onClick(props);
        }
      }}
      onKeyDown={(e) => {
        if (e.key === ' ') {
          e.preventDefault();
          if (!readOnly) {
            props.onClick(props);
          }
        }
      }}
      // style={{ cursor: 'pointer', color: '#007bff' }}
      className={`${readOnly ? 'frr-disable-anchor' : 'pagination-next'}`}
    >
      {value}
    </a>
  );
}

export default ProviderIdLinkRenderer;
